<template>
	<div :class="classes">
		<div
			v-if="showSkeleton"
			class="commitment-placeholder__skeletons"
		>
			<Skeleton class="skeleton" />
			<Skeleton class="skeleton" />
			<Skeleton class="skeleton" />
			<Skeleton class="skeleton" />
			<Skeleton class="skeleton" />
		</div>
		<template v-else>
			<FontAwesomeIcon
				:icon="['fad', 'check-double']"
				class="commitment-placeholder__icon"
			/>
			<h1 class="commitment-placeholder__heading">{{ heading }}</h1>
			<p class="commitment-placeholder__text">{{ text }}</p>
		</template>
	</div>
</template>

<script>
import Skeleton from "primevue/skeleton";

export default {
	name: "CommitmentPlaceholder",
	components: {
		Skeleton,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		heading: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		},
		showSkeleton: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			return {
				"commitment-placeholder": true,
				"commitment-placeholder__skeleton": this.showSkeleton,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.commitment-placeholder {
	text-align: center;
	background: $commitment-placeholder-background-color;
	border-radius: 0.5rem;
	padding: 1.6rem;
}

.commitment-placeholder__icon {
	font-size: 6rem;
	margin-bottom: 1.6rem;
	--fa-primary-color: #{$commitment-placeholder-icon-primary-color};
	--fa-secondary-color: #{$commitment-placeholder-icon-secondary-color};
}

.commitment-placeholder__heading {
	font-style: normal;
	font-weight: 600;
	font-size: 1.26rem;
	line-height: 1.75rem;
	color: $commitment-placeholder-heading-color;
	text-align: center;
}

.commitment-placeholder__text {
	font-style: normal;
	font-weight: normal;
	font-size: 1.05rem;
	line-height: 1.5rem;
	color: $commitment-placeholder-text-color;
	text-align: center;
	padding: 0 20%;
}

.commitment-placeholder__skeletons {
	.skeleton {
		margin-top: 1.5rem;
	}

	.skeleton:first-of-type {
		margin-top: 0;
	}
}
</style>
